import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Configure dayjs
dayjs.extend(customParseFormat);
dayjs.locale('vi');

// Format tiền tệ VNĐ
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

// Format ngày tháng
export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  return dayjs(date).format(format);
};

// Format số lượng
export const formatNumber = (number) => {
  return new Intl.NumberFormat('vi-VN').format(number);
};

// Chuyển đổi trạng thái đơn hàng
export const getOrderStatusText = (statusId) => {
  const statusMap = {
    1: 'Chờ xác nhận',
    2: 'Đang xử lý',
    3: 'Đang giao hàng',
    4: 'Đã giao hàng',
    5: 'Đã hủy',
    6: 'Hoàn trả',
  };
  return statusMap[statusId] || 'Không xác định';
};

// Chuyển đổi màu trạng thái
export const getOrderStatusColor = (statusId) => {
  const colorMap = {
    1: 'orange',
    2: 'blue',
    3: 'cyan',
    4: 'green',
    5: 'red',
    6: 'purple',
  };
  return colorMap[statusId] || 'default';
};

// Validate email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate số điện thoại VN
export const isValidPhone = (phone) => {
  const phoneRegex = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  return phoneRegex.test(phone);
};

// Tạo slug từ string
export const createSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a')
    .replace(/[èéẹẻẽêềếệểễ]/g, 'e')
    .replace(/[ìíịỉĩ]/g, 'i')
    .replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o')
    .replace(/[ùúụủũưừứựửữ]/g, 'u')
    .replace(/[ỳýỵỷỹ]/g, 'y')
    .replace(/[đ]/g, 'd')
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

// Tính toán phần trăm
export const calculatePercentage = (part, total) => {
  if (total === 0) return 0;
  return Math.round((part / total) * 100);
};

// Tạo màu ngẫu nhiên
export const getRandomColor = () => {
  const colors = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57',
    '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
    '#10AC84', '#EE5A24', '#0652DD', '#9C88FF', '#FFC312'
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Deep clone object
export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

// Get file extension
export const getFileExtension = (filename) => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  const result = !!(token && token !== 'undefined' && token !== 'null');
  console.log('isAuthenticated check:', { token, result });
  return result;
};

// Get user info from localStorage
export const getUserInfo = () => {
  const userInfo = localStorage.getItem('userInfo');
  if (!userInfo || userInfo === 'undefined' || userInfo === 'null') {
    return null;
  }
  
  try {
    return JSON.parse(userInfo);
  } catch (error) {
    console.error('Error parsing user info from localStorage:', error);
    // Xóa dữ liệu lỗi khỏi localStorage
    localStorage.removeItem('userInfo');
    return null;
  }
};

// Set user info to localStorage
export const setUserInfo = (userInfo) => {
  try {
    if (userInfo && typeof userInfo === 'object') {
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    } else {
      console.warn('setUserInfo: Invalid userInfo data', userInfo);
    }
  } catch (error) {
    console.error('Error setting user info:', error);
  }
};

// Clear auth data
export const clearAuthData = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userInfo');
};

// Get refresh token from localStorage
export const getRefreshToken = () => {
  const refreshToken = localStorage.getItem('refreshToken');
  return refreshToken && refreshToken !== 'undefined' && refreshToken !== 'null' ? refreshToken : null;
};

// Set refresh token to localStorage
export const setRefreshToken = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    localStorage.removeItem('refreshToken');
  }
};

// Check user permission
export const hasPermission = (requiredRole) => {
  const userInfo = getUserInfo();
  if (!userInfo) return false;
  
  const roleHierarchy = {
    'member': 1,
    'stock': 2,
    'manager': 3,
    'admin': 4
  };
  
  const userLevel = roleHierarchy[userInfo.role] || 0;
  const requiredLevel = roleHierarchy[requiredRole] || 0;
  
  return userLevel >= requiredLevel;
};
